import { Timestamp } from '@angular/fire/firestore';
// import { OutputData } from '@editorjs/editorjs';
import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Award } from '../../models/award.school.model';

export const getAwards = createAction(
  '[School Award] Get Awards',
  props<{
    groupId?: string;
    academicYear?: number;
    gradeId?: string;
    studentId?: string;
    limit?: number;
    lastRecord?: Timestamp;
    allGroups?: boolean;
  }>(),
);

export const addAwardsToStore = createAction(
  '[School Award] Add Awards to store',
  props<{ awards: Award[]; hasMore?: boolean }>(),
);
export const addAwardToStore = createAction(
  '[School Award] Add Award to store',
  props<{ award: Award }>(),
);

export const getAwardsFailure = createAction(
  '[School Award] Get Awards Failed',
  props<{ error: AppExceptionModel }>(),
);

export const getAward = createAction(
  '[School Award] Get award',
  props<{ groupId: string; awardId: string }>(),
);

export const getAwardFailure = createAction(
  '[School Award] Get award failure',
  props<{ error: AppExceptionModel }>(),
);

// Create Award Actions
export const create = createAction(
  '[School Award] Create',
  props<{ groupId: string; award: Award }>(),
);
export const createFailure = createAction(
  '[School Award] Create Failure',
  props<{ error: AppExceptionModel }>(),
);
export const createSuccess = createAction(
  '[School Award] Create Success',
  props<{ award: Award }>(),
);

// Update Award Actions
export const update = createAction(
  '[School Award] Update',
  props<{ groupId: string; awardId: string; award: Award }>(),
);
export const updateFailure = createAction(
  '[School Award] Update Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateSuccess = createAction(
  '[School Award] Update Success',
  props<{ award: Award }>(),
);

// Update Award Notes
// export const updateNotes = createAction(
//   '[School Award] Update Notes',
//   props<{ groupId: string; awardId: string; notesData: OutputData }>()
// );
export const updateNotesFailure = createAction(
  '[School Award] Update Notes Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateNotesSuccess = createAction(
  '[School Award] Update Notes Success',
  props<{ award: Award }>(),
);

// Delete Award Actions
export const deleteAction = createAction(
  '[School Award] Delete',
  props<{ groupId: string; id: string }>(),
);
export const deleteFailure = createAction(
  '[School Award] Delete failure',
  props<{ error: AppExceptionModel }>(),
);
export const deleteSuccess = createAction(
  '[School Award] Delete success',
  props<{ id: string }>(),
);

export const deleteFromStore = createAction(
  '[School Award] Clear from store',
  props<{ id: string }>(),
);

export const loadAwardStats = createAction(
  '[School Grade] Load Awards Stats',
  props<{ groupId: string }>(),
);

export const clear = createAction('[School Award] Clear Awards');

export const clearFromStore = createAction(
  '[School Award] Clear multiple from store',
  props<{ ids: string[] }>(),
);

export const clearByAcademicYear = createAction(
  '[School Award] Clear Awards By Academic Year',
  props<{ groupId: string; academicYear: number }>(),
);
